// import Home from './Home.vue'
// import Devhub from './Devhub.vue'
// import Faq from './Faq.vue'
// import Buy from './Buy.vue'
// import Search from './Search.vue'
// import DevProfile from './DevProfile.vue'
// import Updates from './Updates.vue'
// import StatusReports from './StatusReports.vue'
// import DevVideo from './DevVideo.vue'
// import NotFound from './NotFound.vue'

// TODO: divide by chunks
const Home = () => import("./Home.vue");
const Devhub = () => import("./Devhub.vue");
const Faq = () => import("./Faq.vue");
const Buy = () => import("./Buy.vue");
const Search = () => import("./Search.vue");
const Article = () =>
  import(/* webpackChunkName: "articles" */ "./Article.vue");
const NotFound = () => import("./NotFound.vue");
const SurvivorGamez = () => import("./SurvivorGamez.vue");

export { Home, Devhub, Faq, Buy, Search, NotFound, Article, SurvivorGamez };
